export interface SubscriptionLimits {
  monthly_basic_limit: number;
  monthly_advanced_limit: number;
  daily_basic_limit: number;
  daily_advanced_limit: number;
}

export interface SubscriptionPrice {
  monthly: number;
  yearly: number;
}

export interface ModelsData {
  models: Model[];
  user_subscription: string;
  subscription_limits: {
    Free: SubscriptionLimits;
    Plus: SubscriptionLimits;
    Pro: SubscriptionLimits;
    Premium: SubscriptionLimits;
  };
  subscription_price: {
    Free: SubscriptionPrice;
    Plus: SubscriptionPrice;
    Pro: SubscriptionPrice;
    Premium: SubscriptionPrice;
  };
}

export interface MessageLimit {
  daily: number;
  monthly: number;
}

export interface User {
  email: string;
  nickname: string;
  avatar: string | null;
  /** 当前生效的套餐级别(含 referral 赠送 Pro 的影响),用于展示与功能门控 */
  plan_name: string;
  /** 付费购买的套餐级别(不含 referral),供订阅购买逻辑判断"当前已购套餐" */
  paid_plan_name?: string;
  /** 是否可访问 FluidToDo 云同步(referral Pro 或付费订阅) */
  sync_access?: boolean;
  /** referral 赠送 Pro 的到期时间(毫秒时间戳),null/缺省表示无赠送 */
  referral_pro_expiry?: number | null;
  basic_limit: MessageLimit;
  basic_calls_today: number;
  basic_calls_this_month: number;
  advanced_calls_today: number;
  advanced_calls_this_month: number;
  advanced_limit: MessageLimit;
  last_api_call: string | null;  // ISO date string
  referred_by: string | null;
  referral_code: string | null;
  referred_users_count: number | 0;
  referral_bonus_calls: number | 0;
  /** 邀请折扣系数(0.8/0.85/0.92/0.95/1.0),1.0 表示无折扣;购买时取更优惠不叠加 */
  referral_discount?: number | 1;
  plan_expiry: Date | string | null;  // ISO date string or Date object
  provider?: 'apple' | 'tabby';
}

export interface Model {
  id: string;
  name: string;
  subscription_level: string[];
  max_tokens: number;
}

export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  content_type?: string;
  created_at?: string; // ISO date string
  isNew?: boolean; // New property to track if the message is newly added
  modelName?: string;  // Add this field
}

export interface LoginResponse {
  access_token: string;
  user: User;
}

const DEFAULT_BOT_ID = '7420019097200738310';

export const defaultModel: Model = {
  "name": "GPT-4o mini",
  "id": DEFAULT_BOT_ID,
  "max_tokens": 128000,
  "subscription_level": [
      "Free",
      "Plus",
      "Pro",
      "Premium"
  ]
};
